import { getLocalStorage } from '@trinity/chat-components';
import type { LastLoginStrategy } from './interfaces';

export const LocalStorageKeys = Object.freeze({
  LastLoginStrategy: 'msl-copilot:last-login-strategy',
});

export function setLastLoginStrategy(data: LastLoginStrategy.Set.Params) {
  getLocalStorage().setItem(LocalStorageKeys.LastLoginStrategy, JSON.stringify(data));
}

export function getLastLoginStrategy() {
  const $storage = getLocalStorage();

  try {
    const value = $storage.getItem(LocalStorageKeys.LastLoginStrategy);
    if (!value) return null;
    return JSON.parse(value) as LastLoginStrategy.LocalStorage;
  } catch {
    $storage.removeItem(LocalStorageKeys.LastLoginStrategy);
    return null;
  }
}